import React, { useEffect, useState } from 'react'
import './style.sass'
import { useHistory, useLocation } from 'react-router'
import { Collapse, ListGroup, Button } from 'react-bootstrap'

const SideNavigation = ({ categories }) => {
  // ===== Hooks =====
  const history = useHistory()
  const location = useLocation()

  // ==== Local state =====
  const [openedCategoryIds, setOpenedCategoryIds] = useState([])
  const [selectedItem, setSelectedItem] = useState(null)

  // ==== Side effects ====
  useEffect(() => {
    const _selectedItem = getSelectedMenuItem()
    if (_selectedItem) {
      updateOpenedCategoryIds(_selectedItem?.category?.id)
    }
  }, [])

  useEffect(() => {
    const _selectedItem = getSelectedMenuItem()
    if (_selectedItem) {
      setSelectedItem(_selectedItem)
    }
  }, [location.pathname])

  // ==== Methods =====
  const onCategoryClicked = (category) => {
    updateOpenedCategoryIds(category.id)
  }
  
  const onMenuItemClicked = (item) => {
    setSelectedItem(item)
    history.push(item.route)
  }

  const getSelectedMenuItem = () => {
    if (!categories) {
      return null
    }
    const pathname = location.pathname
    for (let a = 0; a < categories.length; a++) {
      const item = categories[a].items.find(j => j?.routeRegex?.test(pathname?.toLowerCase()))
      if (item) return item
    }
  }

  const updateOpenedCategoryIds = (categoryId) => {
    setOpenedCategoryIds(_openedCategoryIds => {
      if (_openedCategoryIds.includes(categoryId)) {
        return _openedCategoryIds.filter(id => id !== categoryId)
      }
      return [..._openedCategoryIds, categoryId]
    })
  }

  return (
    <div className="side-navigation-component-container">
      {categories?.map((category, index) => (
        <div key={`category-${index}`}>
          <label
            onClick={() => onCategoryClicked(category)}
            className={openedCategoryIds?.includes(category.id) ? "active" : ""}
          >
            <div className="sidenav-link">
              <i className="transformable fa fa-chevron-down"></i>
              {category.categoryTitle}
            </div>
          </label>

          <Collapse in={openedCategoryIds?.includes(category.id)}>
            <ListGroup>
              {category.items?.map((item, idx) => (
                <ListGroup.Item key={`category-item-${idx}`}>
                  <Button
                    onClick={() => onMenuItemClicked(item)}
                    className={item.id === selectedItem?.id ? "active sidenav-active-link" : ""} 
                    variant="link"
                  >
                    {item.title}
                  </Button>
                </ListGroup.Item>
              ))}
            </ListGroup>
          </Collapse>
        </div>
      ))}
    </div>
  )
}

export default SideNavigation